import { render, staticRenderFns } from "./JsonDropzone.vue?vue&type=template&id=060ddab6"
import script from "./JsonDropzone.vue?vue&type=script&lang=ts"
export * from "./JsonDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports